import { Component } from '@angular/core';
import { HeaderService, HeaderInformation } from './header-information.service';

@Component({
    selector: 'se-header-information',
    templateUrl: './header-information.component.html',
    styleUrls: ['./header-information.component.scss'],
    standalone: false
})
export class HeaderInformationComponent {
    header$ = this.headerService.header$;

    constructor(private headerService: HeaderService) {}

    isHeaderEmpty(header: HeaderInformation) {
        return !header.left && !header.center && !header.right;
    }
}
